import "./fonts.css";
import "./index.css";

import React from "react";
import ReactDOM from "react-dom/client";
import { RouterProvider } from "react-router-dom";
import { I18nextProvider } from "react-i18next";
import TagManager from "react-gtm-module";

import { router } from "./router";
import { initSentry } from "./sentry";
import { configureCognito } from "./api/auth/cognitoAuth";
import i18n from "./i18n";

initSentry();

configureCognito();

const gtmContainerId = import.meta.env.VITE_GTM_CONTAINER_ID;
if (gtmContainerId) {
  TagManager.initialize({
    gtmId: gtmContainerId,
    dataLayer: {
      pageType: "billing",
    },
  });
}

ReactDOM.createRoot(document.getElementById("root") as HTMLElement).render(
  <React.StrictMode>
    <I18nextProvider i18n={i18n}>
      <RouterProvider router={router} />
    </I18nextProvider>
  </React.StrictMode>
);
